export const LIMIT_PAGE_NEWS = 8;
export const linkMedpro = "https://medpro.vn/";
export const NOT_UPDATE = "Chưa cập nhật";
export const IN_PROCESSING = "Đang xử lý";
export const WAIT_UPDATE = "Đang cập nhật";
export const NOT_EXIST = "Thông tin không tồn tại";
export const CHOOSE_GENDER = "Chọn giới tính";
export const CHOOSE_YEAR = "Chọn năm sinh";
export const MALE = "Nam";
export const FEMALE = "Nữ";
export const YES = "Có";
export const NO = "Không";
export const CLOSE = "Đóng";
export const OK = "Đồng ý";
export const REMOVE = "Xóa";
export const SEND = "Gửi";
export const CONFIRM = "Xác nhận";
export const MORNING = "Buổi sáng";
export const AFTERNOON = "Buổi chiều";
export const ALL_DAY = "Cả ngày";
export const NO_LONGER_DISPLAY = "Không hiển thị lần sau";
export const COOKIE_VIETINBANK = "cookieVietinBank";
export const WRONG_NUMBER = "Vui lòng nhập đúng số điện thoại!";
export const SEARCHING_MESSAGE_ERROR =
  " Rất tiếc! Không có kết quả nào trùng khớp với thông tin bạn tìm kiếm.";
export const FOREIGN_COUNTRY = "Nước ngoài";
export const VIET_NAM = "Việt Nam";
export const OTHER_NUMBER = "Số khác";
export const TITLE_CANCEL_MEDICAL_BILL = "Hủy phiếu khám này ?";
export const CONTENT_CANCEL_MEDICAL_BILL =
  "Bạn có chắc là muốn hủy phiếu khám này khỏi danh sách ?";
export const CONTENT_THANKYOU =
  "Hủy phiếu khám thành công!<br/>Cảm ơn quý khách đã sử dụng dịch vụ";
export const TITLE_RESEND_SMS = "Chọn số điện thoại nhận tin!";
export const SELECT_BOX_BHYT = [
  {
    id: -1,
    name: "Chọn bảo hiểm y tế"
  },
  {
    id: 1,
    name: "Có giấy chuyển BHYT đúng tuyến BV ĐHYD"
  },
  {
    id: 2,
    name: "Tái khám theo hẹn trên toa thuốc BHYT của BV ĐHYD"
  },
  {
    id: 0,
    name: "Không phải các trường hợp trên / Không có BHYT"
  }
];

export const MASK_MA_HO_SO_UMC = "***-9999999";

export const PLACEHOLDER_MA_HO_SO_UMC = "VD: N18-XXXXXXXX";
export const MASK_MA_THANH_TOAN_UMC = "999999aa-9999";
export const PLACEHOLDER_MA_THANH_TOAN_UMC = "VD: 180912TA-0345";

export const NOTI_TYPE = {
  1: "Lịch khám bệnh",
  2: "Lịch khám bệnh",
  3: "Sự kiện / khuyến mãi",
  4: "Hệ thống Medpro",
  5: "Hệ thống Medpro"
};

export const MAX_YEAR_OF_CHILD_UMC = 15;
export const MIN_YEAR_OF_OLD_PEOPLE_UMC = 60;

export const UMC_ERROR_MESSAGE_CHILD_CHICH_NGUA =
  "Trẻ em dưới 15 tuổi, vui lòng chọn chuyên khoa nhi.";

export const UMC_ERROR_MESSAGE_OLD_PEOPLE_LAO_KHOA =
  "Chuyên khoa Lão Khoa chỉ khám, chữa bệnh cho Bệnh nhân từ 60 tuổi trở lên.";

export const PLATFORM_NAME = "web";
export const WEB_NAME = "medpro";

export const DEFAULT_COUNTRY = { id: 222, code: "VN", name: "Việt Nam" };

export const ID_FEATURE_DAT_KHAM = "5ed0659c54bdb00019e4741a";
export const ID_FEATURE_DAT_KHAM_THEO_BAC_SI = "5f2274e060d7f71760004972";
export const ID_FEATURE_THANH_TOAN_VIEN_PHI = "5f0679e5672b040019c7d4d3";

export const FEATURE_TYPES = {
  bookingDate: "booking.date",
  bookingDoctor: "booking.doctor",
  paymentFee: "payment.fee",
  paymentFeeHistory: "payment.fee.history",
  examResultSearch: "payment.fee.search",
  _eInvoice: "payment.invoice",
  eInvoice: "e.invoice",
  khaiBaoYTe: "declare.yt",
  examresult: "exam.profile",
  bookingVaccine: "booking.vaccine"
};

export const SERVICE_TYPE_INSURANCE = "INSURANCE_ONLY";
export const SERVICE_TYPE_NO_INSURANCE = "NO_INSURANCE_ONLY";
export const SERVICE_TYPE_BOTH = "BOTH";
export const CHECK_WITH_INSURANCE_CODE_EXIST =
  "CHECK_WITH_INSURANCE_CODE_EXIST";

export const BANNER_HOME_DESKTOP = "banner_desktop.png";
export const BANNER_HOME_MOBILE = "banner_mobile.png";
export const LOGO_HEADER_COLOR = "header_logo.svg";
export const LOGO_PNG = "logo.png";
export const LOGO_HEADER_WHITE = "logo_header_white.svg";
export const LOGO_FOOTER = "footer_logo.svg";
export const SLIDE = "slide.png";
export const IMG_MA_BENH_NHAN = "bien_lai.png";
export const IMG_MA_THANH_TOAN = "payment_bill.png";

export const SUBJECT = "subject";
export const SERVICE = "service";
export const ROOM = "room";
export const DOCTOR = "doctor";
export const MEDPRO = "medpro";
export const MOMO = "momo";
export const NHIDONG1 = "nhidong1";
export const DHYDUOC = "umc";

// export const PAYMENT_HUB_URL_LOCAL = "http://localhost:9999";
// export const PAYMENT_HUB_URL_TESTING =
//   "https://payment-gateway-qrcode-testing.medpro.com.vn";

export const BASE_URL = window.location.origin + "/umc1";

export const REDIRECT_URL_AFTER_BOOKING = `${BASE_URL}/chi-tiet-phieu-kham-benh`;
export const REDIRECT_URL_AFTER_PAYMENT_FEE = `${BASE_URL}/ket-qua-thanh-toan-vien-phi`;
export const REDIRECT_URL_AFTER_PAYMENT_EXAM = `${BASE_URL}/phieu-kham-benh/chi-tiet/`;
export const GATEWAY_CHECK_STT_TRANSACTION =
  "https://payment-gateway.medpro.com.vn:1234/payment/v1/payin/getTransactionStatus";
export const GATEWAY_RECHECK_STT_TRANSACTION =
  "https://payment-gateway.medpro.com.vn:1234/payment/v1/payin/reCheckTransaction";

export const EXTEND_DATA_TEST =
  "000201010212262200069704360108530BYTQD5204806253037045405230005802VN5917BENH VIEN CHO RAY6003HCM62860120VP2012233H4RH7ZPGNHN0318BENH VIEN CHO RAY 07120520730003850820VP2012233H4RH7ZPGNHN6304AD57";

// 18-1 -> 18/2
export const NOTI =
  "Từ ngày 18.1.2021 đến hết ngày 18.2.2021 ứng dụng miễn phí tiện ích người dùng 10.000 VNĐ trên 1 phiếu đặt khám. Trân trọng!";

export const apiNews = "https://cms.medpro.com.vn";

export const listPartner = [
  {
    // chưa được golive
    description: "phòng khám việt á",
    domain: [],
    partnerId: "pkvieta"
  },
  {
    // chưa được golive
    description: "Bệnh viện Thanh Vũ Bạc Liêu",
    domain: [
      "tvmbaclieu.medpro.com.vn",
      "thanhvubaclieu-testing.medpro.com.vn"
    ],
    partnerId: "tvmbaclieu"
  },
  {
    // chưa được golive
    description: "Bệnh viện Thống Nhất Đồng Nai",
    domain: ["bvtndongnai.medpro.com.vn"],
    partnerId: "bvtndongnai"
  },
  {
    // chưa được golive
    description: "Viện Tim TP Hồ Chí Minh",
    domain: ["vientimhcm.medpro.com.vn"],
    partnerId: "vientimhcm"
  },
  {
    // chưa được golive
    description: "Bệnh viện Đa khoa Trung Tâm Tiền Giang",
    domain: ["bvdktiengiang.medpro.com.vn"],
    partnerId: "bvdktiengiang"
  },
  {
    // chưa được golive
    description: "Bệnh Viện Đa Khoa Đồng Nai 2",
    domain: ["dkdongnai2.medpro.com.vn"],
    partnerId: "dkdongnai2"
  },
  {
    // bị hủy bỏ
    domain: ["umc-v2-testing.medpro.com.vn"],
    partnerId: "umc"
  },
  {
    // live đang version 26
    description: "BỆNH VIỆN QUẬN BÌNH THẠNH",
    domain: ["bvbinhthanh.medpro.com.vn", "bvbinhthanh-testing.medpro.com.vn"],
    partnerId: "binhthanhhcm"
  },
  {
    // live mới
    description: "BỆNH VIỆN ĐA KHOA TRUNG ƯƠNG CẦN THƠ",
    domain: ["bvtwct.medpro.com.vn", "bvtwct-testing.medpro.com.vn"],
    partnerId: "bvtwct"
  },
  {
    // live mới
    description: "BỆNH VIỆN DA LIỄU THÀNH PHỐ HỒ CHÍ MINH",
    domain: [
      "dalieu-testing.medpro.com.vn",
      "dalieu-v2.medpro.com.vn",
      "dalieu-beta.medpro.com.vn",
      "dalieu.medpro.com.vn"
    ],
    partnerId: "dalieuhcm"
  },
  {
    // version live 23
    description: "BỆNH VIỆN ĐA KHOA AN PHƯỚC",
    domain: [
      "anphuochospital-testing.medpro.com.vn",
      "anphuochospital.medpro.com.vn"
    ],
    partnerId: "dkanphuoc"
  },
  {
    // version live 26
    description: "",
    domain: ["pkdkanhao-testing.medpro.com.vn", "anhao.medpro.com.vn"],
    partnerId: "pkdkanhao"
  },

  {
    //  version 26
    description: "BỆNH VIỆN NHI ĐỒNG 1",
    domain: [
      "nhidong1-testing.medpro.com.vn",
      "nhidong1-beta.medpro.com.vn",
      "nhidong1.medpro.com.vn",
      "nhidong1-v2.medpro.com.vn",
      "taikham-nhidong1-testing.medpro.com.vn",
      "taikham-nhidong1.medpro.com.vn"
    ],
    partnerId: "nhidong1"
  },
  {
    // version 28
    description: "Nhi đồng thành phố",
    domain: ["nhidongtp-testing.medpro.com.vn", "nhidongtp.medpro.com.vn"],
    partnerId: "nhidonghcm"
  },
  {
    //  chưa go live
    description: "Chấn thương chỉnh hình",
    domain: ["ctch-testing.medpro.com.vn"],
    partnerId: "ctchhcm"
  },
  {
    //  chưa go live
    description: "Nội tiết trung ương",
    domain: ["noitiettw-testing.medpro.com.vn"],
    partnerId: "noitiettw"
  },
  {
    //  version live 23
    description: "BỆNH VIỆN ĐA KHOA ĐỒNG NAI",
    domain: ["bvdongnai.medpro.com.vn", "dkdongnai-testing.medpro.com.vn"],
    partnerId: "dkdongnai"
  },
  {
    //  live mới nhưng chưa có dịch vụ
    description: "BỆNH VIỆN ĐA KHOA VĨNH LONG",
    domain: ["dkvinhlong.medpro.com.vn", "vinhlong-testing.medpro.com.vn"],
    partnerId: "dkvinhlong"
  },
  {
    //  live mới
    description: "BỆNH VIỆN ĐA KHOA VẠN HẠNH",
    domain: ["benhvienvanhanh.medpro.com.vn", "vanhanh-testing.medpro.com.vn"],
    partnerId: "vanhanh"
  },
  {
    //  chưa được golive
    description: "BỆNH VIỆN TRUYỀN MÁU HUYẾT HỌC",
    domain: [
      "bthh-testing.medpro.com.vn",
      "bthh-staging.medpro.com.vn",
      "bthh.medpro.com.vn"
    ],
    partnerId: "bthh"
  },
  {
    //  chưa được golive
    description: "Bệnh viện nhân dân 115",
    domain: [
      "115-testing.medpro.com.vn",
      "115-staging.medpro.com.vn",
      "bvnd115.medpro.com.vn"
    ],
    partnerId: "115"
  },
  {
    // live mới nhất
    // api 112
    description: "Bệnh viện chợ rẫy",
    domain: [
      "choray-testing.medpro.com.vn",
      "choray-staging.medpro.com.vn",
      "choray.medpro.com.vn",
      "choray-beta.medpro.com.vn",
      "choray-v2.medpro.com.vn"
    ],
    partnerId: "choray"
  },
  {
    //  chưa được golive
    description: "y dược",
    domain: [
      "yduoccs2-testing.medpro.com.vn",
      "yduoccs2-staging.medpro.com.vn"
    ],
    partnerId: "yduoccs2"
  },
  {
    // live mới 36
    description: "BỆNH VIỆN ĐA KHOA KHU VỰC TỈNH AN GIANG",
    domain: ["bvkvcd-testing.medpro.com.vn", "bvkvcd.medpro.com.vn"],
    partnerId: "dkkvangiang"
  },
  {
    //  live mới 38
    description: "BỆNH VIỆN VŨNG TÀU",
    domain: [
      "leloi-testing.medpro.com.vn",
      "leloi-staging.medpro.com.vn",
      "leloi.medpro.com.vn",
      "benhvienvungtau.medpro.com.vn"
    ],
    partnerId: "leloi"
  },
  {
    // thuộc công ty medpro
    // live mới nhất
    description: "công ty medpro",
    domain: [
      "covid19.medpro.com.vn",
      "covid19-testing.medpro.com.vn",
      "medpro.vn",
      "pkh.vn",
      "v2-testing.medpro.com.vn",
      "umc2-news-testing.medpro.com.vn",
      "news-testing.medpro.com.vn",
      "dangkykhambenh.gov.vn",
      "testing.medpro.com.vn",
      "staging.medpro.com.vn",
      "datkham.medpro.com.vn",
      "dangkykham.com.vn",
      "medpro.com.vn",
      "cs-testing.medpro.com.vn",
      "cskh-beta.medpro.com.vn",
      "cs.medpro.com.vn"
    ],
    partnerId: "medpro"
  },
  {
    // live 36
    description: "BỆNH VIỆN TRƯNG VƯƠNG",
    domain: [
      "trungvuong-testing.medpro.com.vn",
      "trungvuong-staging.medpro.com.vn",
      "trungvuonghcm.medpro.com.vn"
    ],
    partnerId: "trungvuong"
  },
  {
    // đang version 29
    description: "",
    domain: [
      "tpbank-testing.medpro.com.vn",
      "tpbank.medpro.com.vn",
      "momo-testing.medpro.com.vn",
      "momo.medpro.com.vn"
    ],
    partnerId: "momo"
  },
  {
    // chưa được golive
    description: "Bệnh viện nhiệt đới",
    domain: [
      "bvbenhnhietdoi.medpro.com.vn", // live chưa dùng
      "bvbenhnhietdoi-testing.medpro.com.vn"
    ],
    partnerId: "bvbnd"
  },
  {
    // chưa được golive
    description: "tỉnh đà nẵng",
    domain: ["danang-testing.medpro.com.vn"],
    partnerId: "medprodanang"
  },

  {
    description: "",
    domain: ["ttub-testing.medpro.com.vn"],
    partnerId: "bvchoray_ttub"
  },
  {
    description: "",
    domain: ["sagomed.medpro.com.vn", "sagomed-testing.medpro.com.vn"],
    partnerId: "medicsaigon"
  },
  { description: "", domain: [], partnerId: "medicsaigon2" },
  { description: "", domain: [], partnerId: "medicsaigon3" },
  { description: "", domain: [], partnerId: "medicsaigon5" },
  {
    // live 36
    description: "Bệnh viện Quốc tế Minh Anh",
    domain: ["minhanh-testing.medpro.com.vn", "minhanh.medpro.com.vn"],
    partnerId: "minhanh"
  },
  {
    //  chưa được golive
    description: "Bệnh viện Quốc tế Phương Châu",
    domain: ["phuongchau-testing.medpro.com.vn", "phuongchau.medpro.com.vn"],
    partnerId: "phuongchau"
  },
  {
    // là demo bỏ qua
    description: "Bệnh viện nextjs-testing",
    domain: ["nextjs-testing.medpro.com.vn"],
    partnerId: "vanhanh"
  },
  {
    //  không chưa web riêng,
    description: "Bệnh viện Đa khoa Quốc Tế Hoàn Mỹ Thủ Đức",
    domain: [
      "hoanmythuduc-testing.medpro.com.vn",
      "hoanmythuduc.medpro.com.vn"
    ],
    partnerId: "hoanmytd"
  }
];

export const patternMobile = /(84|0[3|5|7|8|9])+([0-9]{8})\b/g;
export const patternPhone = /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/;

export const PhongKham = "phongKham";
export const PhongMach = "phongMach";
export const IOS_MEPRO = "https://apps.apple.com/us/app/id1481561748";
export const Android_MEDPRO =
  "https://play.google.com/store/apps/details?id=vn.com.medpro";

export const CLINIC_TYPES = {
  PM: "PM",
  PK: "PK"
};

export const handleAge = partnerId => {
  let _age = 0;

  switch (partnerId) {
    case "nhidong1":
      _age = 16;
      break;

    case "dalieuhcm":
      _age = 6;
      break;

    case "nhidonghcm":
      _age = 18;
      break;

    default:
      _age = 16;
      break;
  }
  return _age;
};

export const tagA = {
  alt: "",
  target: "_blank",
  rel: "noopener noreferrer"
};
export const onContentPage = (value = "") => {
  switch (value) {
    case "gioi-thieu":
      return "GioiThieu";
    case "thac-mac":
      return "ThacMac";
    case "dieu-khoan-dich-vu":
      return "DieuKhoan";
    case "chinh-sach-bao-mat":
      return "ChinhSach";
    case "huong-dan":
      return "HuongDan";
    case "quy-trinh":
      return "QuyTrinh";
    case "quy-dinh-su-dung":
      return "QuyDinh";
    default:
      return "";
  }
};
export const Delpath = (value = "") => {
  const pathName = value.replace("/", "");
  return pathName;
};
export const HospitalStepOnePatient = ["umc2", "umc"];

export const listAppId = ["medpro", "momo", "vnptpay"];

export const partnerAppId = ["momo", "vnptpay"];
